import { cloneDeepWith } from 'lodash';
// eslint-disable-next-line no-restricted-imports -- Use the SDK contract for boundary types.
import { type CaptureResult } from 'posthog-js';

import { isDefined, isTruthy } from 'common';

function stripUrlQuery(value: string) {
  if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) {
    return value;
  }
  try {
    const url = new URL(value);
    url.search = '';
    url.hash = url.hash.split('?')[0];
    return url.toString();
  } catch {
    return value.split('?')[0];
  }
}

/** Urls may carry patient identifiers in query params, and the SDK copies them into many properties, so strip queries from every url in the payload. */
export function stripUrlQueries(event: CaptureResult | null): CaptureResult | null {
  if (!isDefined(event)) {
    return null;
  }
  const sanitizedEvent: CaptureResult = cloneDeepWith(event, (value: unknown) =>
    typeof value === 'string' ? stripUrlQuery(value) : undefined
  );
  // The app uses a hash router, so location.pathname is always the app root and the route lives in the hash.
  const routePath = window.location.hash.replace(/^#/, '').split('?')[0];
  if (isTruthy(routePath.length)) {
    sanitizedEvent.properties.$pathname = routePath;
  }
  return sanitizedEvent;
}
